import { twMerge } from "tailwind-merge"
import { Icon, type IconProps } from "../../../ui/icon/Icon"

// TODO: Move this out of Chart and to a more common place

type EmptyStateProps = {
  icon?: IconProps["as"]
  headingText: string
  bodyText: string
  actions?: React.ReactNode
  size?: "small" | "medium"
}

const sizeLookup: Record<
  NonNullable<EmptyStateProps["size"]>,
  {
    heading: {
      className: string
    }
    body: {
      className: string
    }
    icon: {
      className: string
    }
  }
> = {
  small: {
    heading: {
      className: "text-base",
    },
    body: {
      className: "text-sm",
    },
    icon: {
      className: "w-6 h-6",
    },
  },
  medium: {
    heading: {
      className: "text-lg",
    },
    body: {
      className: "text-sm",
    },
    icon: {
      className: "w-8 h-8",
    },
  },
}

const EmptyState = ({ icon, headingText, size = "medium", bodyText, actions }: EmptyStateProps) => {
  const { heading: headingProps, body: bodyProps, icon: iconProps } = sizeLookup[size]

  return (
    <div className="flex flex-col gap-5 items-center justify-center px-16 py-16">
      {icon && <Icon as={icon} {...iconProps} style={{ opacity: 0.5 }} />}
      <div className="flex flex-col items-center gap-2 text-center mb-2">
        <h3 className={twMerge("text-base font-medium", headingProps.className)}>{headingText}</h3>
        <div className={twMerge("text-sm", bodyProps.className)} style={{ maxWidth: "380px" }}>
          {bodyText}
        </div>
      </div>
      {actions && <div className="flex gap-2 items-center justify-between">{actions}</div>}
    </div>
  )
}

export default EmptyState
